import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';

// Public: anyone holding a certificate (or an employer checking one) can
// confirm it is genuine by its number or QR code.
const VerifyCertificate = () => {
  const { number } = useParams();
  const navigate = useNavigate();
  const [input, setInput] = useState(number || '');
  const [state, setState] = useState(number ? 'loading' : 'idle');
  const [cert, setCert] = useState(null);

  useEffect(() => {
    if (!number) { setState('idle'); return; }
    setState('loading');
    api.get(`/certificates/verify/${encodeURIComponent(number)}`)
      .then(r => { setCert(r.data); setState('found'); })
      .catch(err => setState(err.response?.status === 404 ? 'notfound' : 'error'));
  }, [number]);

  const submit = (e) => {
    e.preventDefault();
    const n = input.trim().toUpperCase();
    if (n) navigate(`/verify/${encodeURIComponent(n)}`);
  };

  const row = (label, value) => value && (
    <div style={{ display: 'flex', gap: 12, padding: '8px 0', borderBottom: '1px solid #f3f4f6' }}>
      <div className="text-muted" style={{ width: 130, flexShrink: 0 }}>{label}</div>
      <div style={{ fontWeight: 500 }}>{value}</div>
    </div>
  );

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      background: 'linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fed7aa 100%)'
    }}>
      <div className="card" style={{ maxWidth: 520, width: '100%' }}>
        <div className="text-center mb-4">
          <img src="/lp-logo.png" alt="Light Pharma" style={{ height: 50, marginBottom: 12 }} />
          <h2 style={{ color: '#ea580c', fontSize: 18 }}>Certificate Verification</h2>
        </div>

        {state === 'loading' && <p className="text-center text-muted">Checking...</p>}

        {state === 'found' && cert && (
          <div className="mb-4">
            <div className={`alert ${cert.valid ? 'alert-success' : 'alert-error'}`} style={{ textAlign: 'center', fontWeight: 600 }}>
              {cert.valid ? '✓ This certificate is genuine and valid' : '✗ This certificate has been withdrawn and is no longer valid'}
            </div>
            {row('Certificate No.', cert.number)}
            {row('Awarded to', cert.recipient_name)}
            {row('Certificate', cert.kind_label)}
            {row('Programme', cert.title)}
            {cert.title !== cert.course_title && row('Course', cert.course_title)}
            {row('Company', cert.company_name)}
            {row('Dates', cert.dates_text)}
            {row('Issued', new Date(cert.issued_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }))}
            {row('Issued by', 'Light Pharma')}
          </div>
        )}

        {state === 'notfound' && (
          <div className="alert alert-error mb-4" style={{ textAlign: 'center' }}>
            No certificate was found with number <strong>{number}</strong>. Please check the number and try again.
          </div>
        )}
        {state === 'error' && <div className="alert alert-error mb-4">Could not check the certificate right now. Please try again later.</div>}

        <form onSubmit={submit}>
          <div className="form-group">
            <label>{state === 'found' ? 'Check another certificate' : 'Certificate number'}</label>
            <input type="text" value={input} onChange={e => setInput(e.target.value)} placeholder="e.g. LP-CPI-2610-K7M2QX"
              style={{ textTransform: 'uppercase' }} />
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%' }}>Verify</button>
        </form>
      </div>
    </div>
  );
};

export default VerifyCertificate;
